
import {GET_LOCATIONS, GET_STATES,GET_PROGRAMS} from '../actions/LocationAction'

const initialState ={   
    locations:[],
    primaryLocationId: -1,
    states:[],
    programs:[]    
}

const LocationReducer =  (state= initialState, action)=>{   
    switch(action.type){       
        case GET_LOCATIONS:                      
            return {...state, locations:action.locations, primaryLocationId:action.id}       
        case GET_STATES:
            return {...state, states:action.states }
        case GET_PROGRAMS:
            return {...state, programs:action.programs}
        default:
            return {...state}
    }
}

export default LocationReducer;